import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import { Trash, PencilSquare } from "react-bootstrap-icons";
import AdminSidebar from "../../layouts/AdminSidebar";
import { authCall } from "../../../services";
import AppConstants from "../../../appConstants";

function LiseWifiSqueeze() {
  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      const resp = await authCall("getWifiSqueeze", {});
      if (resp?.type === "success") {
        setList(resp?.payload);
        setLoading(false);
      }
    }
    fetchData();
  }, []);

  const handleDelete = (el) => {
    toast.warning(
      <div>
        <p>Are you sure you want to delete?</p>
        <Button
          variant="success"
          className="btn-sm"
          onClick={() => deleteItem(el)}
        >
          Yes
        </Button>
        <Button
          variant="danger"
          className="btn-sm"
          style={{ marginLeft: "2px" }}
          onClick={closeToast}
        >
          No
        </Button>
      </div>,
      {
        position: "top-center",
        autoClose: false,
        closeOnClick: false,
        draggable: false,
        closeButton: false,
      }
    );
  };

  const deleteItem = async (el) => {
    const resp = await authCall("deleteWifiSqueeze", {
      squeezId: el.id,
      isSoft: false,
    });
    if (resp?.type === "success") {
      closeToast();
      const updatedItems = list.filter((item) => item.id !== el.id);
      setList(updatedItems);
      toast.success("Deleted successfully.");
    }
  };

  const closeToast = () => {
    toast.dismiss();
  };

  const handleEdit = (details) => {
      navigate(AppConstants.routes.admin.addWifiSqueeze, { state: { details } });
    };

  return (
    <>
      <div className="update-machine-page common-table-design py-4">
        <div className="container custom-container">
          <div className="row">
            <div className="col-sm-4 col-lg-3 mb-4">
              <AdminSidebar />
            </div>
            <div className="col-sm-8 col-lg-9">
              <div className="common-info-card">
                <div className="heading-title">WIFI Squeezes</div>
                <div className="details-wrapper py-lg-4">
                  <div className="table-responsive">
                    <table className="table table-borderless table-custom m-0">
                      <thead>
                        <tr>
                          <th scope="col">Id:</th>
                          <th scope="col">Logo:</th>
                          <th scope="col">BG Image:</th>
                          <th scope="col">QR Image:</th>
                          <th scope="col">Company:</th>
                          <th scope="col">Version:</th>
                          <th scope="col">Header Color:</th>
                          <th scope="col">Fields:</th>
                          <th scope="col">Welcome URL:</th>
                          <th scope="col">Success URL:</th>
                          <th scope="col">Action:</th>
                        </tr>
                      </thead>
                      <tbody>
                        {!loading &&
                          (list.length > 0 ? (
                            list.map((el, index) => (
                              <tr key={index}>
                                <td>#{el.id}</td>
                                <td>
                                  <img
                                    src={el?.logo}
                                    alt="el.logo"
                                    style={{ width: 80, borderRadius: 5 }}
                                  />
                                </td>
                                <td>
                                  <img
                                    src={el?.background_image}
                                    alt="el.background_image"
                                    style={{ width: 80, borderRadius: 5 }}
                                  />
                                </td>
                                <td>
                                  <img
                                    src={el?.qr_image}
                                    alt="el.qr_image"
                                    style={{ width: 80, borderRadius: 5 }}
                                  />
                                </td>
                                <td>{el.company_name}</td>
                                <td>{el?.squeeze_type}</td>
                                <td>{el?.header_color}</td>
                                <td>{el.header_color}</td>
                                <td>{el.welcome_url}</td>
                                <td>{el.success_url}</td>
                                <td>
                                  <div className="icon-container">
                                    <PencilSquare
                                      onClick={() => handleEdit(el)}
                                      className="cursor-pointer"
                                      style={{
                                        color: "#ddb12e",
                                      }}
                                    />
                                    <Trash
                                      onClick={() => handleDelete(el)}
                                      className="cursor-pointer"
                                      style={{
                                        color: "red",
                                      }}
                                    />
                                  </div>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={10} className="text-center">
                                No record found
                              </td>
                            </tr>
                          ))}
                        {loading && (
                          <tr>
                            <td colSpan={10} className="text-center">
                              Loading...
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default LiseWifiSqueeze;
